const getVisitClassificationNamesEnum = () => {
    return VisitClassificationNamesEnum;
}
const getActionAddItemEnum = () => {
    return ActionAddItemEnum;
}

const getVisitClassificationEnum = () => {
    return VisitClassificationEnum;
}

const getVisitClassificationClientActionEnum = () => {
    return VisitClassificationClientActionEnum;
}

const getVisitClassificationValidationSchemaTypesEnum = () => {
    return VisitClassificationValidationSchemaTypesEnum;
}

const getFinancialStatusEnum = () => {
    return FinancialStatusEnum;
}

const getGenderEnum = () => {
    return GenderEnum;
}

const getPaymentMethodsEnum = () => {
    return PaymentMethods;
}
const getEmergencyApprovalEnum = () => {
    return Emergencies;
}

const getClaimStatusEnum = () => {
    return ClaimStatus;
}

const getTransactionTypesEnum = () => {
    return TransactionTypes;
}
const getWarehouseTransactionTypes = () => {
    return WarehouseTransactionTypes;
}
const getPreviewResult = () => {
    return PreviewResult;
}
const getAddItemType = () => {
    return AddItemType;
}

const getSaveReceptionistVisitServicResult = () => {
    return SaveReceptionistVisitServicResult;
}
const getArabicSupportEnum = () => {
    return ArabicSupportEnum;
}
const getWarehouseStatusEnum = () => {

    return WarehouseStatusEnum;
}

const getGetProductDetailsResultEnum = () => {

    return GetProductDetailsResultEnum;
}

const getCPOEStatusEnum = () => {

    return CPOEStatusEnum;
}

const getPageSizeEnum = () => {
    return pageSizeEnum;
}

const getPaymentRecieptEnum = () => {
    return PaymentRecieptEnum
}
//const getApprovalStatusEnum = () => {
//    return ApprovalStatusEnum;
//}

const getAttachmentSaveResult = () => {
    return AttachmentSaveResult;
}

const getByOrderVisitCreationTypeEnum = () => {
    return ByOrderVisitCreationTypeEnum;
}
const getTabFilterationEnum = () => {
    return TabFilterationEnum;
}
const getItemStatusEnum = () => {
    return ItemStatusEnum;
}

const getWarehouseLocationsResponseEnum = () => {
    return WarehouseLocationsResponseEnum;
}

const getWarehouseFunctionEnum = () => {
    return WarehouseFunctionEnum;
}

const getPrepareIvFluidResponseEnum = () => {
    return PrepareIvFluidResponseEnum;
}

const getInitOwnMedicationPopupResult = () => {
    return InitOwnMedicationPopupResult
}

const getSaveVirtualWarehouseItemReponse = () => {
    return SaveVirtualWarehouseItemReponse;
}
const geturgencyTypeEnum = () => {
    return urgencyType;
}

const getClaimValidationStatus = () => {
    return ClaimValidationStatus;
}

const ClaimValidationStatus = {
    NotClaimedNotVlaidated: 0,
    Validated: 1,
    Claimed: 2,
    ValidatedClaimed: 3
}

const ItemStatusEnum = {
    AllReceiptItemsFullyReturned : 4,
    NotContainsAnyItems : 5
}
const pageSizeEnum = {
    A4: 1,
    A7: 2,
    Bracode: 3
}

const PaymentRecieptEnum = {
    Visit: 3,
    RecieptPayment:4
}

const WarehouseStatusEnum = {
    Done: 1,
    NotAvailable: 2,
    OtherException: 3,
    NotAllowedReturnQuantityExceedsDispensedQuantity: 4,
    UOMnotMatchedwithProduct: 5,
    OrderUOMnotMatchedWithProduct: 6,
    ProductIsnotExist: 7,
    WarhouseFrozen:9,
    WarehouseAssignedNotExsit: 101

}

const GetProductDetailsResultEnum = {
    Success: 1,
    Failure:2,
    InvalidBarcode: 3,
    InvalidProduct: 4,
    EmployeeNotAssigned: 5,
    ProductNotActiveOrDeleted: 6,
    NotAvailableBatches: 7,
    ExpiredBarcode: 8
}

const CPOEStatusEnum = {
    PerformedQuantityIsMoreThanReturnedQuantity : 6,

}


const SaveReceptionistVisitServicResult = {
    Success: 1,
    Failure: 2,
    MappedService: 3,
    ActionNotAllowed: 4,
    Concurrency: 5,
    NotAllowedFromOrderLine: 7,
    FailureInBilling: 12,
    StopActionHasPerformedQuantity: 50,
    NotAvailableFromWarehouse: 51,
    hasAllergy: 80,
    WarehouseAssignedNotExsit:101
}

const AddItemType = {
    SearchMode: 2,
    BracodMode: 1
}
const ClaimStatus = {
    Claimed: 2,
    NotClaimed: 1
}

const PaymentMethods = {
    Cash: 1,
    CreditCard: 2,
    DirectDebit: 3,
    SelfPaid: 4
}

const Emergencies = {
    Routin: 1,
    STAT: 2,
    PRN: 3
}
const AvailableQtyResultEnum = {
    Success: 1,
    InValidID: 2,
    EmployeeNotAssigned: 3,
    ProductNotAssigned: 3,
    FailureOrMissingData:4
}

const TransactionTypes = {
    In: 1,
    Out: 2,
    Downpayment: 3,
}
const WarehouseTransactionTypes = {
    Dispense: 2,
    Return: 1,
}
const PreviewResult =
{
    Failed: 2,
    InvalidReceipt: 5
}
const FilterationTabsEnum =
{
    PhysicianOrder: 1,
    DispenseHistory: 2,
    Prescription: 3
}

const ServedByEnum = {
    Nurse: 1,
    Receptionist: 2,
    Pharmacist: 3,
    LabTechnician: 4,
    System: 5,
    OR: 6,
    Others: 7
}

const AddedServiceTypeEnum = {
    ServiceLine: 1,
    OrderSets: 2,
    PhysicianOrders: 3,
    ByOthers: 4,

}

const VisitServiceClassificationEnum = {
    MedicalService: 3,
    Procedure: 4,
    LABService: 5,
    RADService: 6,
    Medication: 1,
    Packages: 8,
    OR: 9,
    MedicalConsumable: 2,
    BloodProducts: 10,

};
const RequestedJobCategoryEnum = {
    Internal: 1,
    External: 2
};

const CreateWalkInVisitStepsEnum = {
    Patient: 1,
    Info: 2,
    AddItem: 3
};

const CreateByOrderVisitStepsEnum = {
    Info: 1,
    Medication: 2,
    AddItem: 3
};

const AddItemSourceScreenEnum = {
    DispensingHistory: 1,
    Prescription: 2,
    PhysicianOrder: 3

};

const PrescriptionTabRadioTypeEnum = {
    WalkIn: 2,
    ByOrder: 1

};

const DispenseHistoryTabRadioTypeEnum = {
    Visits: 3,
    PaymentReceipts: 4

};
const AdvancedFilterTypeEnum = {
    Regular: 1,
    IvFluid: 2

};

const DispenseToNurseResultEnum = {
    Success: 1,
    NotAllowed: 2,
    Failed: 3

};

const CreateByOrderTypeConfigEnum = {
    CreateNew: 1,
    SameVisit: 2,
};

const OrderCreationNeedEnum = {
    Approval: 1,
};

const OrderCreatedByEnum = {
    Physician: 1,
    Pharmacist: 2
};

const SaveApprovalRequetActionResultEnum = {
    Success: 1,
    Failure: 2,
    SomthingWentWrongWithCPOE: 10
};

const ApprovalLetterStatusEnum = {
    Posted: 1,
    Sent: 2,
    Hold: 3,
    Approved: 4,
    Rejected: 5
}

const OrderFrequencyUnitEnum = {
    Hour: 2,
    Day: 3,

}

const getOrderFrequencyUnitEnum = () => {
    return OrderFrequencyUnitEnum;
}

const getAvailableQtyResultEnum = () => {
    return AvailableQtyResultEnum;
}

const getApprovalLetterStatusEnum = () => {
    return ApprovalLetterStatusEnum;
}

const getSaveApprovalRequetActionResultEnum = () => {
    return SaveApprovalRequetActionResultEnum;
}

const getOrderCreatedByEnum = () => {
    return OrderCreatedByEnum;
}

const getOrderCreationNeedEnum = () => {
    return OrderCreationNeedEnum;
}

const getCreateByOrderTypeConfigEnum = () => {
    return CreateByOrderTypeConfigEnum;
}

const getDispenseToNurseResultEnum = () => {
    return DispenseToNurseResultEnum;
}

const getCreateByOrderVisitStepsEnum = () => {
    return CreateByOrderVisitStepsEnum;
}

const getPrescriptionTabRadioTypeEnum = () => {
    return PrescriptionTabRadioTypeEnum;
}
const getDispenseHistoryTabRadioTypeEnum = () => {
    return DispenseHistoryTabRadioTypeEnum;
}
const getAdvancedFilterTypeEnum = () => {
    return AdvancedFilterTypeEnum;
}
const getCreateWalkInVisitStepsEnum = () => {
    return CreateWalkInVisitStepsEnum;
}

const getAddItemSourceScreenEnum = () => {
    return AddItemSourceScreenEnum;
}

const getRequestedJobCategoryEnum = () => {
    return RequestedJobCategoryEnum;
}

const getVisitServiceClassificationEnum = () => {
    return VisitServiceClassificationEnum;
}

const getAddedServiceTypeEnum = () => {
    return AddedServiceTypeEnum;
}

const getServedByEnum = () => {
    return ServedByEnum;
}

const getFilterationTabsEnum = () => {
    return FilterationTabsEnum;
}

const getApprovalLetterAssignLevelEnum = () => {
    return ApprovalLetterAssignLevelEnum;
}

const getServiceApprovalEnum = () => {
    return ServiceApprovalEnum;
}

const getNeedApprovalEnum = () => {
    return NeedApprovalEnum;
}
const getReceiptClassEnum = () => {
    return ReceiptClassEnum;
}

const getSaveResultEnum = () => {
    return SaveResultEnum;
}

const getPharamcyReturnResult = () => {
    return PharamcyReturnResult;
}

const getOrderLineStatusEnum = () => {
    return OrderLineStatus;
}

const getServiceNoteTypeEnum = () => {
    return ServiceNoteType;
}
const getCreateVisitResultEnum = () => {
    return CreateVisitResult;
}

const getCreatedByModuleForMedicationEnum = () => {
    return CreatedByModuleForMedicationEnum;
}

const getVisitTypeEnum = () => {
    return VisitTypeEnum;
}

const getRevertDischargedVisitResult = () => {
    return RevertDischargedVisitResult;
}

const getAttachmentDeleteResult = () => {
    return AttachmentDeleteResult;
}

const getMedicationCreationNeedIdEnum = () => {
    return MedicationCreationNeedIdEnum;
}

const getInitReturnByReceiptEnum = () => {
    return InitReturnByReceiptEnum;
}

const getPrepareIVMedicationDoseEnum=()=>{
    return PrepareIVMedicationDoseEnum;
}

const PrepareIVMedicationDoseEnum={
    Success : 1,
    Failure : 2,
    NtAllwed :3
}

const MedicationCreationNeedIdEnum = {
    Approval: 1,
    Alternative: 2,
    Both: 3
}


const SaveResultEnum =
{
    SavedSuccess: 1,
    FailedToSave: 2,
    Concurrency: 3,
    NotAllowedAction: 4,
    NotValidStatus: 8,
    FailureInBilling: 12,
    AlreadyChangedToCash: 13,
    FailureInOdoo: 14,
    FailedToDischargeVisit: 15,
    HasClaimedService: 38,
    NotAllowedRefundAmmount: 2001,
    NotValidReciept: 5,
    CannotEditClaimed: 2002,
    VisitHasStockableItem: 88,
    VisitAlreadyInvoiced: 7,
    NotAllowedFromOrderLine: 20,
    Blocked: 100,
    StopActionHasPerformedQuantity: 50,
    NotAvailableFromWarehouse: 57,
    PatientIsAllergic: 58,
    VisitCancelledOrDischarged: 59,
    hasClaimedService: 38,
    ValidatedService: 2007,
    ClaimedAndValidatedService: 2008,
    FinanceFailure: 2006
};

const PharamcyReturnResult =
{
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    WarehouseAssignedNotExsit: 4,
    ActionNotAllowed: 5,
    CannotEditClaimed: 6,
    CannotEditValidated: 8,
    CannotEditClaimedValidated: 9
};

const CreateVisitResult = {
    ValidRecord: 0,
    SavedSuccess: 1,
    FailedToSave: 2,
    Concurrency: 3,
    SavedSuccessWithArrivalConfirm: 4,
    SavedSuccessFailedToConfirm: 5,
    NoMappedService: 6,
    NoDataForMappedService: 7,
    InvalidVisitStatus: 8,
    DefaultService: 11,
    FailureInBilling: 12,
    FailureInOdoo: 14, //// odoo didn't accept the visit to be discharged and invoiced
    FailedToDischargeVisit: 15,/////in case the visit has no priced services so can't be discharged,
    PatientHasOpenVisits: 16,
    NotAuthorized: 17,
    NotAllowedFromOrderLine: 20,
    StopActionHasPerformedQuantity: 50,
    CPOENotAllowed: 30,
    PackageHasAssignedServices: 31,
    NeedToConfirmDischargeCurrentVisit: 32,
    ConcurrencyVisit: 33,
    NotAllowedAction: 35,
    VisitHasOpenAppointment: 36,
    VisitOutOfRule: 37,
    VisitHasClaimedServices: 38,
    ClaimedService: 52,
    RequestAlreadyExist: 53,
    NotAllowedFromCPOEToChnageAdmissionOrderStatus: 54,
    FailureFromCPOEToChnageAdmissionOrderStatus: 55,
    SuccesFromCPOEToChangeAdmissionOrderStatus: 56,
    NotAvailableFromWarehouse: 57,
    PatientIsAllergic: 58,
    VisitCancelledOrDischarged: 59,
    SuccessWithNotAvailableServices: 60,
    WarehouseAssignedNotExsit: 61,
    MissingContractorID: 201,
    hasZeroPrice: 302,
    ValidatedService: 305,
    ClaimedAndValidatedService: 306,
}

const EditPharmacyVisitServiceClaim = {
    ValidatedService: 103,
    ClaimedAndValidatedService: 104
}

const ReceiptClassEnum = {
    Normal: 1,
    Pharmacy: 2
}

const CreatedByModuleForMedicationEnum = {
    InternalPhysician: 1,
    Pharmacy: 5
}
const VisitTypeEnum = {
    Ambulatory: 8,
}

const NeedApprovalEnum = {
    NotNeedApproval: 0,
    NormalNeedApproval: 1,
    PricingNeedApproval: 2,
    Approved: 3
}

const ServiceApprovalEnum = {
    NotNeedApproval: 0,
    NeedAuthorizationApproval: 1,
    NeedFinancialApproval: 2
}
const VisitClassificationNamesEnum = {
    Outpatient_En: "Outpatient",
    Outpatient_Ar: "عيادات خارجية",
    InPatient_En: "Inpatient",
    InPatient_Ar: "داخلى",
    Ambulatory_En: "Ambulatory",
    Ambulatory_Ar: "خارجي",
    Emergency_En: "ER",
    Emergency_Ar: "طوارئ"
};

const VisitClassificationEnum = {
    Outpatient: 1,
    InPatient: 2,
    Ambulatory: 3,
    Emergency: 4
}

const VisitClassificationClientActionEnum = {
    ViewOutpatient: "ViewOutpatient",
    ViewInpatient: "ViewInpatient",
    ViewAmbulatry: "ViewAmbulatry",
    ViewER: "ViewER"
}

const VisitClassificationValidationSchemaTypesEnum = {
    OutPatient: 2,
    Ambulatory: 5,
    Emergency: 4,
    InPatient: 3

};

const FinancialStatusEnum = {
    Cash: 1,
    Insured: 2,
}

const GenderEnum = {
    Male: 1,
    Female: 2,
    Unspecified: 3
}

const ApprovalLetterAssignLevelEnum = {
    SingleServiceAssign: 1,
    MultiServiceAssign: 2,
    VisitLevel: 3
}

const OrderLineStatus = {
    Ordered: 1,
    Discontinued: 2,
    InProgress: 3,
    Complete: 4,
    Dismissed: 5
}

const RevertDischargedVisitResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    NotAllowedToRevertVisit: 4,
    NotAllowedToRevertVisitToCancelled: 5,
    VisitStateAlreadyReverted: 6,
    hasvalidatedInovice: 7
}


const ServiceNoteType = {
    Public: 1,
    Private: 2
}
const ArabicSupportEnum = {
    ArabicLang: "ar",
    AM_Ar: "ص",
    PM_Ar: "م",
    AM_En: "AM",
    PM_En: "PM",
    To_En: "to",
    To_Ar: "إلي",
    Minute_En: "min",
    Hourse_En: "hrs",
    Minute_Ar: "دقيقة",
    Hourse_Ar: "ساعات",
    Lang_LocalStorage_Key: "NG_TRANSLATE_LANG_KEY"
};
const getAttachTypeEnums = () => {
    return AttachTypeEnums;
}

let AttachmentSaveResult = {
    Success: 1,
    InvalidAttachmentFileSize: 2,
    InvalidAttachmentFileType: 3,
    InvalidAttachmentFileName: 4,
    Failure: 5,
    PatientAttachmentAlreadyDeleted: 6
}


let AttachTypeEnums = {
    Upload: 0,
    Scan: 1,
};


const AttachmentDeleteResult = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    NotAllowed: 4
}

const InitReturnByReceiptEnum = {
    Valid: 1,
    Invalid: 2,
    Invoiced: 3
}

const ByOrderVisitCreationTypeEnum = {
    SaudiVisitCreation: 1,
    EgyptVisitCreation: 2
}

const TabFilterationEnum = {
    PhysicianOrdersTab: 1,
    DispenseHistoryTab: 2,
    PrescriptionTab: 3

}

const WarehouseLocationsResponseEnum = {
    Successful: 1,
    NotValidID: 2,
    MissingData: 3
}

const WarehouseFunctionEnum = {
    ReturnDelivery:4
}

const PrepareIvFluidResponseEnum = {
    Success : 1,
    VMFailure : 2,
    VMNotAllowed : 3,
    IVPreparationProductNotConfigured: 4,
    ReprintSuccess : 5,
    ReprintFailed: 6,

    CPOEFailure : 100,
    CPOENotFound : 101,
    CPOENotFluid : 102,
    CPOEOrderStatusNotValid : 103,
    CPOEAlreadyPrepared : 104,
    CPOEConcurrency : 105
}

const InitOwnMedicationPopupResult = {
    Success : 1,
    Failure : 2,
    VisitNotExist : 3,
    ActionNotAllowed : 4
}

const SaveVirtualWarehouseItemReponse = {
    Success : 1,
    Failre : 2,
    VisitNotExist : 3,
    Concurrency : 4,
    QuantityIsLessThanDispensed : 5,
    DispensedQuantityGTZero : 6,
    CannotEditMedication : 7,
    ActionNotAllowed : 8
}
const urgencyType = {
    PRN: 3,
    STAT: 2,
    REGULAR: 1
}
const StabilityTypesEnum={
    InFridge:1,
    OutsideFridge:2
}

const getStabilityTypesEnums = () => {
    return StabilityTypesEnum;
}
const PreparationTypesEnum={
    Add:0,
    Edit:1,
  
}
const ActionAddItemEnum = {
    ExceedQty:1,
    changeBatch:2,
  
}

const getPreparationTypesEnum = () => {
    return PreparationTypesEnum;
}

const IVDosageFrequencyPer = {
    Minute: 1,
    Hour: 2
}

const getIVDosageFrequencyPer = () => {
    return IVDosageFrequencyPer
}

const RecieptSearchBehavaior = {
    AddClicked: 1,
    RemoveClicked: 2,
}
const getRecieptSearchBehavaior = () => {
    return RecieptSearchBehavaior

}

const AppointmentRuleConfigEnum = {
    MultipleVisits: 1,
    MultipleAppointment: 2
}
const getAppointmentRuleConfigEnum = () => {
    return AppointmentRuleConfigEnum
}
const patientObjTypeEnum = {
    Dummy: 1,
    Normal: 2
}
const getpatientObjTypeEnum = () => {
    return patientObjTypeEnum
}
const itemAddModeEnum = {
    ByBarcode: 1,
    BySearch: 2
}
const getitemAddModeEnum = () => {
    return itemAddModeEnum
}
const orderedByEnum = {
    Physician: 1,
    Pharmacisit: 2
}
const getorderedByEnum = () => {
    return orderedByEnum
}
const getEditPharmacyVisitServiceClaim = () => {
    return EditPharmacyVisitServiceClaim
}

export {
    getEditPharmacyVisitServiceClaim,
    getInitReturnByReceiptEnum, getAttachmentDeleteResult,
    getCPOEStatusEnum,
    getAttachmentSaveResult,
    getAttachTypeEnums,
    getRevertDischargedVisitResult,
    getVisitClassificationNamesEnum,
    getPharamcyReturnResult, getVisitClassificationEnum,
    getVisitClassificationClientActionEnum, getVisitClassificationValidationSchemaTypesEnum,
    getFinancialStatusEnum, getGenderEnum,
    getApprovalLetterAssignLevelEnum, getPaymentMethodsEnum,
    getClaimStatusEnum, getServiceApprovalEnum, getNeedApprovalEnum,
    getTransactionTypesEnum, getReceiptClassEnum, getSaveResultEnum,
    getPreviewResult, getFilterationTabsEnum, getServedByEnum, getAddedServiceTypeEnum,
    getVisitServiceClassificationEnum, getRequestedJobCategoryEnum, getAddItemSourceScreenEnum,
    getCreateWalkInVisitStepsEnum, getPrescriptionTabRadioTypeEnum, getDispenseHistoryTabRadioTypeEnum, getCreateByOrderVisitStepsEnum,
    getOrderLineStatusEnum, getServiceNoteTypeEnum, getAddItemType, getSaveReceptionistVisitServicResult, getCreateVisitResultEnum,
    getDispenseToNurseResultEnum, getCreateByOrderTypeConfigEnum, getCreatedByModuleForMedicationEnum, getArabicSupportEnum,
    getVisitTypeEnum, getWarehouseStatusEnum, getPageSizeEnum, getOrderCreationNeedEnum,
    getOrderCreatedByEnum, getSaveApprovalRequetActionResultEnum, getEmergencyApprovalEnum,
    getApprovalLetterStatusEnum, getMedicationCreationNeedIdEnum, getOrderFrequencyUnitEnum,
    getAvailableQtyResultEnum, getPaymentRecieptEnum, getByOrderVisitCreationTypeEnum,
    getTabFilterationEnum, getItemStatusEnum, getWarehouseLocationsResponseEnum,
    getWarehouseFunctionEnum, getWarehouseTransactionTypes, getAdvancedFilterTypeEnum,
    getGetProductDetailsResultEnum, getPrepareIvFluidResponseEnum,
    getInitOwnMedicationPopupResult, getSaveVirtualWarehouseItemReponse, geturgencyTypeEnum,
    getPrepareIVMedicationDoseEnum, getStabilityTypesEnums, getPreparationTypesEnum,
    getIVDosageFrequencyPer, getRecieptSearchBehavaior, getAppointmentRuleConfigEnum, getpatientObjTypeEnum, getitemAddModeEnum, getorderedByEnum,
    getClaimValidationStatus, getActionAddItemEnum
};